import React, { useRef, useEffect } from 'react'
import { request } from "../../../config/helpers/axios-instance";
import { toast } from 'react-toastify';
const Contexts = require("../../../contexts");
import "../../../styles/Signup.scss";
import md5 from 'md5';
// import ReCAPTCHA from "react-google-recaptcha";
// import { verifyCaptcha } from '../../../utils/helpers';

export const getHashedRequestOTPToken = (data) => {
    const secretKey = process.env.REACT_APP_OTP_SECRET_KEY;
    const encrypted = md5(secretKey + data.toString() + secretKey);


    const response = {
        b: encrypted
    }

    return response
}

function SignInForm() {
    const { authState, authDispatch } = React.useContext(Contexts.Auth);
    // const captchaRef = useRef(null);
    const ref = useRef()
    const onSubmit = async (e) => {
        if (!authState.contact_no) {
            toast.error("Please fill all the fields")
            return
        }

        e.preventDefault()

        const sentAt = Date.now()
        const analytics = getHashedRequestOTPToken(sentAt)

        const response = await request({
            url: `user/loginOtp`,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: {
                username: authState.contact_no,
                sentAt,
                analytics,
                // captchaToken: authState.captchaToken
            },
            checkRefresh: false
        });

        if (response.status === 200 && response.data.error === "") {
            authDispatch({ ...authState, step: 1 });
            toast.success("Success, Please Provide OTP send to your Phone");
        } else {
            toast.warn(response.data.error);
        }
    };

    // function onExpired() {
    //     captchaRef.current?.reset();
    // }

    // const [isVerified, setIsverified] = useState(false)

    // async function handleCaptchaSubmission(token) {
    //     if (!authState.contact_no) {
    //         toast.error("Please enter your phone number")
    //         captchaRef.current?.reset();
    //         return
    //     }

    //     try {
    //         const res = await verifyCaptcha(authState.contact_no, token)
    //         if (res === true) {
    //             setIsverified(true)
    //             authDispatch({ ...authState, captchaToken: token })
    //         } else {
    //             setIsverified(false)
    //             toast.error("Captcha verification failed")
    //             captchaRef.current?.reset();
    //         }
    //     } catch (err) {
    //         toast.error("Captcha verification failed")
    //         captchaRef.current?.reset();
    //     }
    // }
    useEffect(() => {
        ref.current.focus()
    }, [])
    return (
        <>
            <div className="flex flex-col w-96 items-center justify-center gap-10 px-6 py-8 mx-auto md:h-screen lg:py-0">
                <h1 className="font-sans text-6xl font-bold mb-4">
                    PillEngine
                </h1>
                <div className="w-[400px] bg-white-50 rounded-2xl shadow-soft-xl ">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8 flex flex-col items-center">
                        <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl font-sans">
                            Sign in to your account
                        </h1>
                        <form className='w-full' onSubmit={(e) => onSubmit(e)}>
                            <div>
                                <label className="block mb-2 text-sm font-medium text-gray-900 ">
                                    Your Mobile
                                </label>
                                <input
                                    type="contact_no"
                                    name="contact_no"
                                    id="contact_no"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-2xl focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 focus:outline-0"
                                    placeholder="Enter Your Number Here"
                                    maxLength={10}
                                    ref={ref}
                                    required={true}
                                    value={authState.contact_no}
                                    onChange={(e) => {
                                        if (!isNaN(e.target.value)) {
                                            authDispatch({ ...authState, contact_no: e.target.value })
                                        }
                                    }
                                    }
                                />

                            </div>
                            {/* <ReCAPTCHA
                                ref={captchaRef}
                                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                onChange={handleCaptchaSubmission}
                                onExpired={onExpired}
                                className='mt-3 '
                            /> */}
                            <button
                                disabled={!authState.contact_no}
                                type="submit"
                                id="signup"
                                className="w-full font-sans text-white-50bg-green-600 hover:bg-green-700t hover:text-white focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-2xl text-sm px-5 py-2.5 text-left mt-3">
                                Sign in
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export { SignInForm };